module.exports = __webpack_public_path__ + "favicon-5d64ebfb1c0fe1ea9915b8189e373653.ico";